import script from "./PagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePreview.vue?vue&type=script&setup=true&lang=js"

import "./PagePreview.vue?vue&type=style&index=0&id=11464a8a&lang=scss&scoped=true"
import "./PagePreview.vue?vue&type=style&index=1&id=11464a8a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11464a8a"]])

export default __exports__